module.exports = __webpack_public_path__ + "static/media/scrum.a32724a0.png";